import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isShowing: false,
  selectedWindow: null,
  selectedMetric: "hours_windalarm_total",
  maxHoursWindAlarm: 0,
};

const windAlarmWindowSlice = createSlice({
  name: "windAlarmWindow",
  initialState,
  reducers: {
    showWindAlarmWindow: (state, action) => {
      state.isShowing = true;
      state.selectedWindow = action.payload;
    },
    hideWindAlarmWindow: (state) => {
      state.isShowing = false;
    },
    setSelectedWindAlarmMetric: (state, action) => {
      state.selectedMetric = action.payload;
    },
    setMaxHoursWindAlarm: (state, action) => {
      state.maxHoursWindAlarm = action.payload;
    },
  },
});

export const {
  showWindAlarmWindow,
  hideWindAlarmWindow,
  setSelectedWindAlarmMetric,
  setMaxHoursWindAlarm,
} = windAlarmWindowSlice.actions;

export default windAlarmWindowSlice.reducer;
